module.exports = __webpack_public_path__ + "static/media/sort-by-attributes-interface-button-option.7b17cc61.svg";